<template>

  <div class="feedItem panel bg-lightest black">
    <div class="w-100 font-weight-600"><span class="ml-1">Next Departures</span></div>
    <router-link :to="{ name: 'calendar' }">
      <div class="px-0 pt-4 d-flex h-100" v-if="rows.length > 0">

        <list class="w-100" :header="header" :body="body" :rows="rows" :actions="actions"></list>

      </div>
      <div class="px-0 py-5 w-100 text-center font-weight-600 medium fs-larger" v-else>
        No data
      </div>
    </router-link>
  </div>

</template>

<script>
import List from '@/tools/list/baseList'
import { mapGetters, mapActions} from 'vuex'

export default {
  created: function() {
    // *******************************
    // Requests API for today's events
    // needs to be changed for today only, not the month
    // testing
    // *******************************

    this.loadEvents(
      moment(new Date).startOf('day').format('YYYY-MM-DD'),
      moment(new Date).endOf('day').format('YYYY-MM-DD')
    );

    // sets time filter to paint the departures red, in this case the ones happening in the next hour.
    function isCloseToHappening(startHour){
      let timefilter = moment().add(1, 'hour');
      let eventHour = moment(startHour, "h:mm");

      return eventHour.isBefore(timefilter);
    }

    // List Custom Cells
    var vm = this;
    this.body.customCells = {
        time: function(row) {
          var rowIndex = vm.rows.indexOf(row);

          if(isCloseToHappening(row.time)){
            return '<span class="color-6 font-weight-600">' + row.time + '</span>';
          } else {
            return row.time
          }
        },
        event: function(row) {
          var rowIndex = vm.rows.indexOf(row);

          if(isCloseToHappening(row.time)){
            return '<span class="color-6 font-weight-600">' + row.product + '</span>';
          } else {
            return row.product
          }
        },
        availability: function(row) {
          var rowIndex = vm.rows.indexOf(row);

          if(isCloseToHappening(row.time)){
            return '<span class="color-6 font-weight-600">' + row.availability + '</span>';
          } else {
            return '<span class="font-weight-600">' + row.availability + '</span>';
          }
        },
        checkin: function(row) {
          var rowIndex = vm.rows.indexOf(row);

          if(isCloseToHappening(row.time)){
            return '<span class="color-6 font-weight-600">' + row.checkin + '</span>';
          } else {
            return row.checkin
          }
        }
    };

  },
  data: function() {
    return {
        rows:[],
        header: {
            selection: {
                active: false,
                event: function(event) {}
            },
            list: {
              'time':'Time',
              'event':'Event',
              'availability':'Availability',
              'checkin':'Check-in'
            },
        },
        body: {
            selection: {
                active: false,
                event: function(event) {}
            },
            customRowEvent: this.sharedRowEvent,
            customCells: null,
        },
        actions: {
            label : 'Actions',
            list: [],
        }
    }
  },
  props: {
    cardInfo: {
      type: Object
    }
  },
  computed: {
      ...mapGetters([
          'getReservations',
          'getReservationsLabels',
          'account'
      ])
  },
  methods: {
    ...mapActions([
      'fetchUserDetails'
    ]),
    loadEvents: function(start, end) {
        try {
          //this.fetchUserDetails().then(() => {
              axios.get('api/calendar/GetEvents', { params: {
                  supplierId: this.account.supplierId, //hardcoded
                  dateFrom: start,
                  dateTo: end
              }}).then(response => {
                  if (response && response.status === 200) {
                    if(response.data.events.length > 0){
                      this.selectedEventName = response.data.events[0].product.name; //sets the selectedEventName for the dropdown
                      this.populateCard(response.data.events);
                      this.errorNoData = false;
                    }
                  }
              });
          //});
        }
        catch (error) {
        }
    },
    populateCard: function(eventsArr){
      var dataArr = [];
      let timeNow = moment().subtract(20, 'minutes');

      // sort by depart time
      eventsArr.sort(function(a, b){
        if(moment(a.start).isAfter(moment(b.start))){
          return 1
        } else if(moment(a.start).isBefore(moment(b.start))){
          return -1
        } else {
          return 0
        }

      });


      // create array
      for (let singleEvent of eventsArr) {
        let startHour         = moment(singleEvent.start).format('H:mm');
        let eventName         = singleEvent.product.name;
        let productName       = singleEvent.product.name;
        let availability      = singleEvent.quantityAvailable;
        let lotation          = singleEvent.maximumLotation;
        let available         = singleEvent.quantityAvailable;
        let checkins          = 0;
        let stringCheckins    = checkins+'/'+(lotation-available);


        let timeEvent = moment(startHour, "h:mm");
        if(timeEvent.isAfter(timeNow)){
          dataArr.push({
            'time'          :startHour,
            'event'         :eventName,
            'product'       :productName,
            'availability'  :availability,
            'checkin'       :stringCheckins
          });
        }


      }

      this.rows = dataArr;

    }
  },
  components: {
      List
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .feedItem{
    height: auto !important;
  }
</style>



// WEBPACK FOOTER //
// FeedcardDepartures.vue?22c1e3ee